import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import NextQuestionButton from '../NextQuestionButton';
import CameraIcon from '../../ui/icons/CameraIcon';
import styled from 'styled-components';
import Button from '../../ui/Button';
import { Flex } from '../../ui/Flex';
import UploadFile from '../../ui/fields/input/UploadFile';
import CropIcon from '../../ui/icons/CropIcon';
import RotateIcon from '../../ui/icons/RotateIcon';
import { v4 as uuid4 } from 'uuid';
import { Field } from 'formik';
import backCropImage from '../../../images/backCrop.jpg';
import backBlurImage from '../../../images/backBlur.jpg';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectRegister,
    setBackIdImage,
    setBackIdUrl,
    setCurrentQuestion,
} from '../../../store/reducers/registerSlice';
import CaptureImage from './CaptureImage';
import { base64ToFile } from '../../../utils/base64ToFile';
import EditImage from './EditImage';
import { useTranslation } from 'react-i18next';
import { useUploadFileMutation } from '../../../store/RTKQuery/upload/uploadFile';
import { questions } from '../Register';

const Question8BackIdStyle = styled.div`
    h3.title {
        margin-bottom: 5px !important;
    }

    h4 {
        color: #2f5496;
    }

    .or {
        color: #0070c0;
    }

    .imageNote {
        color: #0070c0;
    }
`;

interface IProps {}
const Question8BackId: FC<IProps> = () => {
    const dispatch = useDispatch();
    const { backIdImage, backIdUrl } = useSelector(selectRegister);
    const [isCaptureImageNow, setIsCaptureImageNow] = useState<Boolean>(false);
    const [isEditImageNow, setIsEditImageNow] = useState<Boolean>(false);
    const { t } = useTranslation();
    const [uploadImage, { data, isLoading, isSuccess }] =
        useUploadFileMutation();
    const nextPageNumber: number = 9;
    const goToNextPage = () => {
        dispatch(
            setCurrentQuestion(
                questions.filter((q) => q.page === nextPageNumber)[0],
            ),
        );
    };
    useEffect(() => {
        if (isSuccess && data) {
            dispatch(setBackIdUrl(data.file_path));
            goToNextPage();
        }
    }, [isSuccess]);
    return (
        <Question8BackIdStyle>
            <h3 className="title">{t('imageOfTheBackOfYourID')}</h3>
            {!isCaptureImageNow && (
                <p className={'subtitle'}>
                    {t('makeSureItMatchesTheDetailsYouProvidedEarlier')}
                </p>
            )}
            <Flex direction={'column'} alignItems={'center'}>
                {!backIdImage.original ? (
                    <>
                        {!isCaptureImageNow ? (
                            <>
                                <button
                                    className={'capture'}
                                    type={'button'}
                                    onClick={() => {
                                        setIsCaptureImageNow(true);
                                    }}
                                >
                                    <CameraIcon />
                                </button>
                                <p className={'captureWithPhoneCamera'}>
                                    {t('captureWithPhoneCamera')}
                                </p>
                                <p className="or">{t('or')}</p>
                                <Field
                                    name={'back_id_imageFormData'}
                                    text={t('uploadImage')}
                                    className={'uploadImage'}
                                    onChange={(
                                        event: ChangeEvent<HTMLInputElement>,
                                    ) => {
                                        if (event.currentTarget.files) {
                                            dispatch(
                                                setBackIdImage({
                                                    original:
                                                        event.currentTarget
                                                            .files[0],
                                                    upload: event.currentTarget
                                                        .files[0],
                                                }),
                                            );
                                        }
                                    }}
                                    component={UploadFile}
                                />
                            </>
                        ) : (
                            <CaptureImage
                                cameraType={'environment'}
                                onCapture={(imageSrc) => {
                                    dispatch(
                                        setBackIdImage({
                                            original: base64ToFile(
                                                imageSrc,
                                                'BackIdImage',
                                            ),
                                            upload: base64ToFile(
                                                imageSrc,
                                                'BackIdImage',
                                            ),
                                        }),
                                    );
                                    setIsCaptureImageNow(false);
                                }}
                                onBack={() => {
                                    setIsCaptureImageNow(false);
                                }}
                            />
                        )}{' '}
                    </>
                ) : (
                    <>
                        {isEditImageNow && backIdImage.original ? (
                            <EditImage
                                onEdit={(imageSrc) => {
                                    dispatch(
                                        setBackIdImage({
                                            original: backIdImage.original,
                                            upload: base64ToFile(
                                                imageSrc,
                                                'BackIdImage',
                                            ),
                                        }),
                                    );
                                    dispatch(setBackIdUrl(''));
                                    setIsEditImageNow(false);
                                }}
                                image={backIdImage.original}
                                onBack={() => {
                                    setIsEditImageNow(false);
                                }}
                            />
                        ) : (
                            <>
                                {backIdImage.upload && (
                                    <img
                                        src={URL.createObjectURL(
                                            backIdImage.upload,
                                        )}
                                        alt=""
                                        className={'imagePreview'}
                                    />
                                )}
                                {/*  <Flex
                                    alignItems={'center'}
                                    gap={10}
                                    className={'imageEditActions'}
                                    marginBottom={20}
                                >
                                    <button
                                        type={'button'}
                                        onClick={() => {
                                            setIsEditImageNow(true);
                                        }}
                                    >
                                        <CropIcon />
                                    </button>
                                    <button
                                        type={'button'}
                                        onClick={() => {
                                            setIsEditImageNow(true);
                                        }}
                                    >
                                        <RotateIcon />
                                    </button>
                                </Flex>*/}

                                <div className={'uploadImageConfirmActions'}>
                                    <Button
                                        text={t('captureAgain') || ''}
                                        variant={'outline'}
                                        handleClick={() => {
                                            dispatch(
                                                setBackIdImage({
                                                    original: null,
                                                    upload: null,
                                                }),
                                            );
                                            dispatch(setBackIdUrl(''));
                                        }}
                                    />
                                    <NextQuestionButton
                                        canNext={true}
                                        nextPage={nextPageNumber}
                                        text={t('yesContinue') || ''}
                                        isLoading={isLoading}
                                        onClick={() => {
                                            if (!backIdUrl) {
                                                const formData = new FormData();
                                                formData.append(
                                                    'file',
                                                    backIdImage.upload as File,
                                                );
                                                uploadImage(formData);
                                            } else {
                                                goToNextPage();
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        )}
                    </>
                )}
                {!isCaptureImageNow && (
                    <Flex direction={'column'} gap={20} width={'100%'}>
                        <h4>
                            {t(
                                'Capture a Clear Photo of Your Egyptian National ID (Back)',
                            )}
                        </h4>
                        <Flex
                            direction={'column'}
                            gap={10}
                            marginBottom={30}
                            width={'100%'}
                        >
                            <Flex
                                alignItems={'center'}
                                gap={10}
                                wrap={'nowrap'}
                                key={uuid4()}
                            >
                                <img
                                    className={'imageReference'}
                                    src={backCropImage}
                                    alt=""
                                />
                                <p className={'imageNote'}>
                                    {'- ' + t('Document is not Cropped')}
                                </p>
                            </Flex>
                            <Flex
                                alignItems={'center'}
                                gap={10}
                                wrap={'nowrap'}
                                key={uuid4()}
                            >
                                <img
                                    className={'imageReference'}
                                    src={backBlurImage}
                                    alt=""
                                />
                                <p className={'imageNote'}>
                                    {'- ' + t('Document is not Blurred')}
                                </p>
                            </Flex>
                        </Flex>
                    </Flex>
                )}
            </Flex>
        </Question8BackIdStyle>
    );
};
export default Question8BackId;
